import {SetResolveCallback} from "../pages/component/dialog.tsx";
import type {AppThunk} from "./index.ts";
import {openDialog} from "./dialog.slice.ts";


/**
 * Alert 창을 엽니다. 사용자가 '확인'을 누를 때까지 기다립니다.
 */
export const askAlert = (title: string, message: string): AppThunk<Promise<void>> =>
  async (dispatch: any) => {
    dispatch(openDialog({ type: 'alert', title, message }));

    return new Promise<void>((resolve) => {
      // boolean 값을 받지만 alert에서는 사용하지 않음
      SetResolveCallback(() => resolve());
    });
  };

/**
 * Confirm 창을 엽니다. 사용자의 선택(true/false)을 Promise로 반환합니다.
 */
export const askConfirm = (title: string, message: string): AppThunk<Promise<boolean>> =>
  async (dispatch: any) => {
    dispatch(openDialog({ type: 'confirm', title, message }));

    return new Promise<boolean>((resolve) => {
      SetResolveCallback(resolve);
    });
  };
